export type TextPart = { type: 'text'; text: string };

export type ImagePart = {
  type: 'image_url';
  image_url: {
    url: string;
    name?: string;
    size?: number;
  };
};

export type MessageContent = string | Array<TextPart | ImagePart>;

export type MessageStatus = 'complete' | 'thinking' | 'streaming' | 'stopped' | 'error';

export type ChatMessage = {
  id: string;
  role: 'user' | 'assistant';
  content: MessageContent;
  createdAt: number;
  modelAlias?: string;
  modelName?: string;
  imageGeneration?: { prompt: string; options: ImageGenerationOptions };
  /** Chain-of-thought tokens streamed before the final answer (not persisted after complete). */
  reasoning?: string;
  status?: MessageStatus;
  error?: string;
};

export type Conversation = {
  id: string;
  title: string;
  messages: ChatMessage[];
  createdAt: number;
  updatedAt: number;
};

export type ModelOption = {
  alias: string;
  name: string;
  description: string;
  supports_vision?: boolean;
  [key: string]: unknown;
};

export type PendingImage = {
  dataUrl: string;
  name: string;
  size: number;
};

export const DEFAULT_IMAGE_MODEL = 'cx/gpt-5.5-image' as const;

export type ImageGenerationOptions = {
  size: '1024x1024' | '1024x1536' | '1536x1024';
  quality: 'low' | 'medium' | 'high';
  outputFormat: 'png' | 'jpeg' | 'webp';
};

export type StoredChatState = {
  version: 2;
  activeId: string;
  conversations: Conversation[];
};
